// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shortDescriptionWrapper__lYBmG {
  position: relative;
  padding: 1px;
}
.shortDescriptionWrapper__lYBmG .shortDescription__a3ckp {
  width: 100%;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--table-box-shadow);
}
.shortDescriptionWrapper__lYBmG .shortDescription__a3ckp .shortDescriptionHeader__S4qkI {
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  display: grid;
  grid-template-columns: 150px 280px 1fr 110px;
  gap: 10px;
  justify-content: space-between;
  padding: 15px 30px;
}
@media (max-width: 810px) {
  .shortDescriptionWrapper__lYBmG .shortDescription__a3ckp .shortDescriptionHeader__S4qkI {
    grid-template-columns: 150px 150px 1fr 110px;
  }
}
.shortDescriptionWrapper__lYBmG .shortDescription__a3ckp .shortDescriptionHeaderItem__S7gvg {
  text-align: start;
  color: var(--tables-title-text);
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}
.shortDescriptionWrapper__lYBmG .shortDescription__a3ckp .shortDescriptionBody__DViap {
  width: 100%;
}
.shortDescriptionWrapper__lYBmG .shortDescription__a3ckp .shortDescriptionBodyRow__WYHZp {
  display: grid;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  grid-template-columns: 150px 280px 1fr 110px;
  justify-content: space-between;
  padding: 15px 30px;
  width: 100%;
  gap: 10px;
}
@media (max-width: 810px) {
  .shortDescriptionWrapper__lYBmG .shortDescription__a3ckp .shortDescriptionBodyRow__WYHZp {
    grid-template-columns: 150px 150px 1fr 110px;
  }
}
.shortDescriptionWrapper__lYBmG .shortDescription__a3ckp .shortDescriptionItem__Iy2J9 {
  color: var(--tables-primary-row-text-main);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}
.shortDescriptionWrapper__lYBmG .shortDescription__a3ckp .shortDescriptionTags__zWr1G .shortDescriptionTag__QgeOQ {
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 10px;
  width: -moz-fit-content;
  width: fit-content;
  text-transform: lowercase;
  border: 1px solid var(--tables-primary-row-icon);
  color: var(--tables-primary-row-icon);
}

.blockHead__pq4F5 {
  min-height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blockTitle__m9DSq {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.skeletonShortDescriptionItem__BiVyh {
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/ShortDescription/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;EACA,YAAA;AAzEF;AA2EE;EACE,WAAA;EACA,qDAAA;EACA,mCAAA;AAzEJ;AA2EI;EACE,mDAAA;EACA,uCAAA;EACA,aAAA;EACA,4CAAA;EACA,SAAA;EACA,8BAAA;EACA,kBAAA;AAzEN;AA2EM;EATF;IAUI,4CAAA;EAxEN;AACF;AA2EI;EACE,iBAAA;EACA,+BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAzEN;AA4EI;EACE,WAAA;AA1EN;AA6EI;EACE,aAAA;EACA,yDAAA;EACA,qDAAA;EACA,4CAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA3EN;AA6EM;EAVF;IAWI,4CAAA;EA1EN;AACF;AA6EI;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA3EN;AA+EM;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,yBAAA;EACA,gDAAA;EACA,qCAAA;AA7ER;;AAmFA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAhFF;;AAmFA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAhFF;;AAmFA;EACE,YAAA;AAhFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.shortDescriptionWrapper {\n  position: relative;\n  padding: 1px;\n\n  .shortDescription {\n    width: 100%;\n    background: var(--tables-primary-row-surface-default);\n    box-shadow: var(--table-box-shadow);\n\n    .shortDescriptionHeader {\n      border-bottom: 1px solid var(--tables-title-stroke);\n      background: var(--tables-title-surface);\n      display: grid;\n      grid-template-columns: 150px 280px 1fr 110px;\n      gap: 10px;\n      justify-content: space-between;\n      padding: 15px 30px;\n\n      @media (max-width: 810px) {\n        grid-template-columns: 150px 150px 1fr 110px;\n      }\n    }\n\n    .shortDescriptionHeaderItem {\n      text-align: start;\n      color: var(--tables-title-text);\n      font-family: Roboto;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 14px;\n      text-transform: uppercase;\n    }\n\n    .shortDescriptionBody {\n      width: 100%;\n    }\n\n    .shortDescriptionBodyRow {\n      display: grid;\n      border-bottom: 1px solid var(--tables-primary-row-stroke);\n      background: var(--tables-primary-row-surface-default);\n      grid-template-columns: 150px 280px 1fr 110px;\n      justify-content: space-between;\n      padding: 15px 30px;\n      width: 100%;\n      gap: 10px;\n\n      @media (max-width: 810px) {\n        grid-template-columns: 150px 150px 1fr 110px;\n      }\n    }\n\n    .shortDescriptionItem {\n      color: var(--tables-primary-row-text-main);\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 14px;\n    }\n\n    .shortDescriptionTags {\n      .shortDescriptionTag {\n        font-size: 12px;\n        padding: 2px 10px;\n        border-radius: 10px;\n        width: fit-content;\n        text-transform: lowercase;\n        border: 1px solid var(--tables-primary-row-icon);\n        color: var(--tables-primary-row-icon);\n      }\n    }\n  }\n}\n\n.blockHead {\n  min-height: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.skeletonShortDescriptionItem {\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shortDescriptionWrapper": `shortDescriptionWrapper__lYBmG`,
	"shortDescription": `shortDescription__a3ckp`,
	"shortDescriptionHeader": `shortDescriptionHeader__S4qkI`,
	"shortDescriptionHeaderItem": `shortDescriptionHeaderItem__S7gvg`,
	"shortDescriptionBody": `shortDescriptionBody__DViap`,
	"shortDescriptionBodyRow": `shortDescriptionBodyRow__WYHZp`,
	"shortDescriptionItem": `shortDescriptionItem__Iy2J9`,
	"shortDescriptionTags": `shortDescriptionTags__zWr1G`,
	"shortDescriptionTag": `shortDescriptionTag__QgeOQ`,
	"blockHead": `blockHead__pq4F5`,
	"blockTitle": `blockTitle__m9DSq`,
	"skeletonShortDescriptionItem": `skeletonShortDescriptionItem__BiVyh`
};
module.exports = ___CSS_LOADER_EXPORT___;
